import { i18n } from '@lingui/core'

import type { FormError } from '@twistopayments/design-system/form'

export type RlcPayload = {
  errors?: FormError[] | null
  success?: unknown
}

export type RlcMutationData = Record<string, RlcPayload | string | undefined>

export const getRlcPayloads = (data: RlcMutationData | null | undefined) =>
  Object.values(data ?? {}).filter(
    (payload): payload is RlcPayload => !!payload && typeof payload === 'object'
  )

export const getRlcNonFieldError = (data: RlcMutationData | null | undefined) =>
  getRlcPayloads(data)
    .flatMap((payload) => payload.errors ?? [])
    .find(({ field }) => !field || field === 'nonFieldErrors')

export const getRlcErrorMessage = (message?: string) => {
  // BE leaves errorCode null and serializes RLC action errors as "CODE: detail".
  const code = message?.match(
    /^(INVALID_INPUT|ACTION_NOT_AVAILABLE|TRANSPORT|PDF_GENERATION):/
  )?.[1]

  switch (code) {
    case 'INVALID_INPUT':
      return i18n._({
        id: 'flow.rlc.error.invalidInput',
        message:
          'We could not process the information you submitted. Please check it and try again.',
      })
    case 'ACTION_NOT_AVAILABLE':
      return i18n._({
        id: 'flow.rlc.error.actionNotAvailable',
        message:
          'This action is no longer available. Please reload to continue from your current step.',
      })
    case 'TRANSPORT':
      return i18n._({
        id: 'flow.rlc.error.transport',
        message:
          'We could not complete your request. Please try again in a moment.',
      })
    case 'PDF_GENERATION':
      return i18n._({
        id: 'flow.rlc.error.pdfGeneration',
        message:
          'We could not prepare your document. Please try again in a moment.',
      })
    default:
      return i18n._('error.general.description')
  }
}

export const isValidExpenditure = (value: string | number) =>
  String(value).trim() !== '' &&
  Number.isSafeInteger(Number(value)) &&
  Number(value) >= 0
